import { render, staticRenderFns } from "./superBManager.vue?vue&type=template&id=04769faa&"
import script from "./superBManager.vue?vue&type=script&lang=js&"
export * from "./superBManager.vue?vue&type=script&lang=js&"
import style0 from "./superBManager.vue?vue&type=style&index=0&id=04769faa&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports